import { render, staticRenderFns } from "./WhiteLabelHeader.vue?vue&type=template&id=25cdd07c&scoped=true"
import script from "./WhiteLabelHeader.vue?vue&type=script&lang=js"
export * from "./WhiteLabelHeader.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelHeader.vue?vue&type=style&index=0&id=25cdd07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cdd07c",
  null
  
)

export default component.exports